(function () {
    'use strict';

    angular
        .module('app.campaignOverview')
        .factory('campaignOverviewService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, data, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(data),
                        loader: loader,
                        params: params
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getCampaignOverviewList (data, params, loader) {
                    var url = $rootScope.apiUrl + 'campaign/activity/getLastCampaignActivities';
                    return handleRequest(url, 'GET', data, params, loader);
                }

                function getTotalCampaignActivities(data, params, loader) {
                    var url = $rootScope.apiUrl + 'campaign/activity/getTotalCampaignActivities/' + params;
                    return handleRequest(url, 'GET', data, params, loader);
                }

                function getAllCompanies(data, params, loader) {
                    var url = $rootScope.apiUrl + 'admin/GetAllAdvertiser';
                    return handleRequest(url, 'GET', data, params, loader);
                }

                service.getCampaignOverviewList = getCampaignOverviewList;
                service.getTotalCampaignActivities = getTotalCampaignActivities;
                service.getAllCompanies = getAllCompanies;

                return service;
            }
        ]);
})();
